/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SqdCommonModule } from '../common/sqd-common.module';
import { XaccBrowseComponent } from './xacc-browse.component';
import { XaccConnectorSelectorComponent } from './xacc-connector-selector.component';
import { XaccReentryComponent } from './xacc-reentry.component';
import { XaccBrowseModalComponent } from './xacc-browse-modal.component';
import { XaccPaginationComponent } from './xacc-pagination.component';
import { XaccSelectComponent } from './xacc-select.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    XaccBrowseComponent,
    XaccBrowseModalComponent,
    XaccConnectorSelectorComponent,
    XaccReentryComponent,
    XaccPaginationComponent,
    XaccSelectComponent,
  ],
  imports: [CommonModule, SqdCommonModule, NgbModule],
})
export class XaccModule {}
